import PropTypes from "prop-types";

import React from "react";

// Components
import AlertWithIcon from "@/Layouts/components/MessagesAlert/AlertWithIcon";

// MUI
import { Grid } from "@mui/material";

// Icons
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

export default function TierAlertError(props) {
	const {
		text = "Error",
		alertProps = {
			className: "error-message-span !font-sans !text-[14.5px] !text-alert",
			icon: <ErrorOutlineOutlinedIcon size="small" />,
			textStyle: { marginLeft: "3px" },
		},
		containerProps = {
			alignItems: "center",
			alignContent: "center",
			sx: {
				minHeight: "20px",
			},
		},
	} = props;

	return (
		<Grid item {...containerProps}>
			<AlertWithIcon {...alertProps} text={text} />
		</Grid>
	);
}
TierAlertError.propTypes = {
	text: PropTypes.string,
	alertProps: PropTypes.shape({
		className: PropTypes.string,
		icon: PropTypes.node,
		textStyle: PropTypes.object,
	}),
	containerProps: PropTypes.shape({
		alignItems: PropTypes.string,
		alignContent: PropTypes.string,
		sx: PropTypes.object,
	}),
};
